<template>
  <div>
    <div v-if="isShowDay" :class="$style.day">
      <span :class="$style.dayDate">{{ date }}</span>
    </div>
    <div :class="$style.post">
      <div :class="$style.top">
        <v-popover placement="bottom-end" popoverClass="no-arrow">
          <div :class="$style.actionButton">
            <BaseIcon custom name="ellipsisX" :class="['tooltip-target']" />
          </div>
          <MenuBase
            slot="popover" v-close-popover
            :options="menu"
          />
        </v-popover>
        <div :class="$style.time">{{ time }}</div>
      </div>
      <div :class="$style.imageWrap">
        <img :src="post.image" alt="" :class="$style.image">
      </div>
      <div :class="$style.bottom">
        <p :class="$style.text">{{ post.text }}</p>
        <div :class="$style.buttons">
          <div
            v-if="post.isEnabledLikes"
            :class="[$style.likeBtn, { [$style.active]: post.isLiked }]"
            @click="onLike"
          ></div>
          <div v-if="post.isEnabledComments" :class="$style.commentBtn" @click="isShowInput = !isShowInput"></div>
          <!-- <BaseIcon
            name="share" custom
            :class="$style.shareBtn"
            @click="onShare"
          /> -->
        </div>
        <div :class="$style.likeCount">{{ post.likes }} {{ $t('socialPost.likes') }}</div>
        <SocialCommentInput
          v-if="isShowInput"
          :postId="post.id"
          @close="isShowInput = false"
        />
        <SocialCommentsList :postId="post.id" />
      </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/date'
import { mapActions, mapGetters } from 'vuex'
import MenuBase from '@/components/MenuBase'
import { startOfDay } from 'date-fns'
import SocialCommentsList from './SocialCommentsList'
import SocialCommentInput from './SocialCommentInput'

export default {
  name: 'social-post-list-item',
  components: {
    MenuBase,
    SocialCommentsList,
    SocialCommentInput
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    lastPostsByDay: Object
  },
  data () {
    return {
      isShowInput: false,
      menuMy: [
        {
          name: this.$t('socialPost.editButton'),
          icon: 'pencil-alt',
          handler: () => {
            this.$router.push({
              name: 'social-post-edit',
              params: {
                profileNickname: this.profile.nickname,
                postId: this.post.id
              }
            })
          }
        },
        {
          name: this.$t('socialPost.deleteButton'),
          icon: 'trash-alt',
          handler: () => {
            this.$modal.show('delete-social-post', { postId: this.post.id })
          }
        }
      ],
      menuFollower: [
        {
          name: this.$t('socialPost.reportButton'),
          icon: 'exclamation-triangle',
          handler: () => {
            this.$modal.show('confirm', {
              content: this.$t('socialPost.reportConfirmation'),
              onSubmit: () => {
                this.$modal.show('info', { text: this.$t('socialPost.reportText') })
              }
            })
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      profileById: 'entities/socialProfiles/getProfile'
    }),
    profile () {
      return this.post.profileObj
    },
    isOwn () {
      return this.profile.isOwn
    },
    menu () {
      return this.isOwn ? this.menuMy : this.menuFollower
    },
    date () {
      return format(new Date(this.post.createdAt), 'd MMMM')
    },
    time () {
      return format(new Date(this.post.createdAt), 'H:mm')
    },
    isShowDay () {
      const dayBeginTimestamp = startOfDay(new Date(this.post.createdAt)) * 1
      const firstPost = this.lastPostsByDay[dayBeginTimestamp]
      if (!firstPost) return false
      return firstPost.id === this.post.id
    }
  },
  methods: {
    ...mapActions({
      toggleLike: 'entities/socialPosts/toggleLike'
    }),
    onLike () {
      this.toggleLike({ postId: this.post.id, isLiked: !this.post.isLiked })
    },
    onShare () {
      //
    }
  }
}
</script>

<style module lang="scss">
.day {
  text-align: center;
  margin: 24px 0 12px;
  color: $text-lightest;
  &Date {
    background-color: rgba($main-bg-colored, 0.45);
    padding: 6px 15px;
    border-radius: 15px;
  }
}
.post {
  margin-top: 14px;
  // padding: 10px;
  background-color: $main-bg-light;
  border-top: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  > * {
    color: $text-darkest;
  }
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.actionButton {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  width: 25px;
  height: 48px;
  margin-left: 10px;
  color: $text-mid-dark;
  &:hover {
    color: $text-colored;
  }
}
.time {
  color: $text-mid;
  margin-right: 12px;
}
.imageWrap {
  text-align: center;
}
.image {
  margin: 0 auto;
  max-width: 100%;
  // max-height: 450px;
  object-fit: contain;
}
.bottom {
  margin: 12px;
}
.text {
  margin-bottom: 12px;
  font-size: 16px;
}
.buttons {
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.likeBtn,
.commentBtn {
  width: 28px;
  height: 28px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 8px;
  cursor: pointer;
}
.likeBtn {
  background-image: url('~@/assets/img/ic_like_ss.png');
  &:hover,
  &.active {
    background-image: url('~@/assets/img/ic_like_ss_filled.png');
  }
}
.commentBtn {
  background-image: url('~@/assets/img/ic_circle_hola_ss.png');
}
// .shareBtn {
//   cursor: pointer;
//   font-size: 20px;
// }
.likeCount {
  color: $text-colored;
  font-weight: 500;
}
</style>
